const headers = {
  name: "Inventory transfer",
  navigate: {
    path: [
      {
        name: "Transfer",
        path: "/app/inventory/transfer",
      },
      {
        name: "Add",
        path: "",
      },
    ],
  },
};

export default headers;
